import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      drawer: {
        '& .MuiDrawer-paper': {
          width: 228,
        },
      },
      subheader: {
        position: 'static',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing() * 2,
        margin: '24px auto',
        cursor: 'pointer',
      },
      item: {
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
        borderLeftColor: 'transparent',
        color: sicrediStyle.secondarySicrediDarker,
      },
      itemCurrent: {
        borderLeftColor: sicrediStyle.primarySicrediDark,
        color: sicrediStyle.primarySicredi,
      },
      itemIcon: {
        fontSize: 12,
        color: 'inherit',
        minWidth: 36,
      },
      itemText: {
        fontFamily: '"Exo 2"',
        fontSize: 16,
        fontWeight: 300,
      },
      submenu: {
        '& $item': {
          paddingLeft: theme.spacing() * 3,
        },
        '& $itemCurrent': {
          borderLeftColor: 'transparent',
        },
      },
    }),
  { name: 'LeftMenu' }
);
